import React, { useState, useEffect } from 'react';
import LeftDashboard from '../components/LeftDashboard';
import { fetchStats } from '../api';

export default function ReportsPage({ user, isEmbedded, view, setView, setSelectedCompany, refreshSignal, preloadedStats }) {
  const [stats, setStats] = useState(preloadedStats || null);
  const [loading, setLoading] = useState(!preloadedStats);

  useEffect(() => {
    if (preloadedStats) {
       setStats(preloadedStats);
       setLoading(false);
       return;
    }
    async function getStats() {
      try {
        const data = await fetchStats();
        setStats(data.stats);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    getStats();
  }, [refreshSignal, preloadedStats]);

  const content = (
    <main style={{ minWidth: 0, animation: 'fadeUp 0.4s ease-out' }}>

      <div style={{
        background: 'linear-gradient(135deg, var(--blue), var(--gold-light))',
        padding: '16px 24px', borderRadius: 12, color: '#fff',
        boxShadow: '0 8px 16px -4px rgba(14,165,233,0.3)',
        marginBottom: 12, position: 'relative', overflow: 'hidden'
      }}>
        <div style={{ position: 'absolute', right: -10, top: -20, fontSize: 80, opacity: 0.1 }}>📄</div>
        <h1 style={{ fontFamily: 'var(--display)', fontSize: 28, fontWeight: 900, letterSpacing: -0.5, margin: '0 0 2px' }}>
          {loading ? '...' : (stats?.totalReviews || 0).toLocaleString()}
        </h1>
        <h2 style={{ fontSize: 13, fontWeight: 600, opacity: 0.9, margin: 0, fontFamily: 'var(--sans)' }}>Total Community Reports</h2>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <StatBox title="Platform Health" value="Active" sub="24/7 Monitoring" />
        <StatBox title="Verified Data" value="100%" sub="Community Backed" />
      </div>

      <div style={{ marginTop: 12, background: 'var(--surface)', padding: 16, borderRadius: 10, border: '1px solid var(--border)' }}>
        <h3 style={{ fontSize: 13, margin: '0 0 8px', color: 'var(--text)' }}>Why this matters</h3>
        <p style={{ fontSize: 12.5, lineHeight: 1.5, color: 'var(--text2)', margin: 0 }}>
          Every report contributes to our mission of ending opaque hiring. By sharing your interview experience, you help thousands of other candidates negotiate better and prepare effectively. 
          We aggregate these data points to build the most accurate picture of tech hiring in India.
        </p>
      </div>

      <div style={{ marginTop: 12, border: '1px dashed var(--border)', borderRadius: 12, padding: '30px', textAlign: 'center' }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>🎯</div>
        <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>Help us grow the database</div>
        <p style={{ fontSize: 13, color: 'var(--text2)', maxWidth: 400, margin: '0 auto 20px' }}>Your anonymous kahanis help the entire Indian developer community against ghosting and lowball offers.</p>
        <button 
           onClick={() => setView('home')}
           style={{ background: 'var(--blue)', color: '#fff', border: 'none', padding: '10px 24px', borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}
        >
          Share My Kahani
        </button>
      </div>
    </main>
  );

  if (isEmbedded) return content;

  return (
    <div style={{
      maxWidth: 1100, margin: '0 auto', padding: '16px 24px',
      display: 'grid', gridTemplateColumns: '220px 1fr', gap: 28,
      alignItems: 'start'
    }}>
      <LeftDashboard user={user} view={view} setView={setView} setSelectedCompany={setSelectedCompany} />
      {content}
    </div>
  );
}

function StatBox({ title, value, sub, color = 'var(--blue)' }) {
  return (
    <div style={{ background: 'var(--surface)', padding: 12, borderRadius: 10, border: '1px solid var(--border)' }}>
      <div style={{ fontSize: 10, fontWeight: 600, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 2 }}>{title}</div>
      <div style={{ fontSize: 16, fontWeight: 800, color, marginBottom: 1 }}>{value}</div>
      <div style={{ fontSize: 11, color: 'var(--text2)' }}>{sub}</div>
    </div>
  );
}
